<div style="font-size: 12px;">
    <div class="panel-body">
      <div class="row">
        <div class="col-sm">
          <label class="lable-title">NAME</label>
          <p class="paragraph-text">{{ details?.customer?.out_company_name }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">FIRST AND LAST NAME</label>
          <p class="paragraph-text">{{ details?.customer?.out_first_name }} {{
            details?.customer?.out_last_name }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">STATUS</label>
          <p class="paragraph-text">{{ details?.customer?.out_status_desc }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label class="lable-title">TENANT ID / CONTRACT</label>
          <p class="paragraph-text">{{ details?.customer?.out_tenant_id }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">PHONE</label>
          <p class="paragraph-text">{{ details?.customer?.out_phone }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">NEXT BILLING DATE</label>
          <p class="paragraph-text">{{ details?.customer?.out_next_billing_date }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <label class="lable-title">TENANT DESCRIPTION</label>
          <p class="paragraph-text">{{ details?.customer?.out_tenant_desc }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">EMAIL</label>
          <p class="paragraph-text">{{ details?.customer?.out_email }}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">ADDRESS</label>
          <p class="paragraph-text" class="paragraph-text">{{ details?.customer?.out_address_1 }} {{
            details?.customer?.out_address_2 }} {{ details?.customer?.out_address_3 }} {{
            details?.customer?.out_city}}, {{ details?.customer?.out_region }} {{
            details?.customer?.out_post_code
            }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8">
          <label class="lable-title">Domain Name</label>
          <p class="paragraph-text">{{ prefix }}</p>
        </div>
        <div class="col-sm-4">
          <button 
            [disabled]="!authService?.currentUserHasAdminAccess()"
            [matTooltipDisabled]="authService?.currentUserHasAdminAccess()"	
            matTooltip="Requires Admin Permissions"
            class="button button-red button-mid edit-enduser"
            (click)="editEndUserDetail($event)"
          >Edit End User</button>
        </div>
      </div>

      <!-- Paymen Detail Section-->

      <div class="row">
        <div class="col-sm">
          <div class="flex-item agreement-margin"><span class="highlight-text">PAYMENT DETAILS</span>
            <div class="basic-icon">
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="col-sm" style="padding-left: unset;">

          <label class="lable-title">
            PAYMENT METHOD
          </label>
          <p></p>
          <ng-container *ngIf="paymentMethod">
            <p class="paragraph-text payment-method">Digital Wallet</p>
            <p class="paragraph-text">{{paymentMethod?.out_card_scheme}}</p>
            <p class="paragraph-text">{{paymentMethod?.out_account_name}}</p>
            <p class="paragraph-text">{{paymentMethod?.out_masked_card_number}} Expires
              {{paymentMethod?.out_expiry}}
            </p>
          </ng-container>

        </div>

        <div class="col-sm" style="padding-left: unset;">
          <button
            [disabled]="!authService?.currentUserHasPurchaseAccess()"
            [matTooltipDisabled]="authService?.currentUserHasPurchaseAccess()"	
            matTooltip="Requires Purchasing Permissions"
            (click)="editPaymentDetails($event)"
            class="button button-red button-mid edit-enduser">
            Edit Payment Details</button>
          <br />
          <br />
        </div>

      </div>
      
      <!-- Customer permission -->
      <div class="row">
        <div class="col-sm">
          <div class="row-spacing"><span class="highlight-text">CUSTOMER PERMISSIONS</span>
            <div class="basic-icon">
            </div>
          </div>
        </div>
      </div>
      <div [formGroup]="form">
        <div class="row">
          <div class="col-sm">
            <div class="row-spacing">                               
              <span>Allow users to purchase Azure Reserved Instance</span>
              <mat-slide-toggle
                class="mx-4"
                formControlName="azureRIPurchaseToggle"
                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                matTooltip="Requires Purchasing Permissions"
                (change)="toggleAzureRIPurchaseRight($event)"
              >
              </mat-slide-toggle>
              <mat-spinner *ngIf="ARIPRTLoadingSpinner" mode="indeterminate"
                class="azure-right-toggle" diameter="20">
              </mat-spinner>                         
          </div>
          </div>
        </div>
        <div class="row" *ngIf="showAzureCMToggle">
          <div class="col-sm">
            <div class="row-spacing">                                                    
              <span>Allow users to view Azure cost management</span>
              <mat-slide-toggle
              class="mat-slide-toggle-ACM"
                formControlName="azureCMViewToggle"
                (change)="toggleAzureCMView($event)"
                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                matTooltip="Requires Purchasing Permissions"
              >
              </mat-slide-toggle>
              <mat-spinner *ngIf="ACMVTLoadingSpinner" mode="indeterminate"
                class="azure-right-toggle" diameter="20">
              </mat-spinner>                          
          </div>
        </div> 
      </div>                  
        <div class="row" *ngIf="showAzureSPToggle">
          <div class="col-sm">
            <div class="row-spacing">                           
              <span>Azure savings plan</span>
              <mat-slide-toggle class="mat-slide-toggle-ASP"                            
                formControlName="azureSavingsPlanToggle"
                (change)="toggleAzureSavingsPlan($event)"
                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                matTooltip="Requires Purchasing Permissions"
              >
              </mat-slide-toggle>
              <mat-spinner *ngIf="AZSPLoadingSpinner" mode="indeterminate"
                class="azure-right-toggle" diameter="20">
              </mat-spinner>                        
          </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm"
          *ngIf="!isSubscriptionResponseLoading && (subscriptionResponse?.status == 'Success' || subscriptionResponse?.status == 'MCA')">
          <div class="flex-item agreement-margin"><span class="highlight-text">MICROSOFT CUSTOMER AGREEMENT</span>
            <div class="basic-icon eye-icon eye-icon-position"
              (click)="btnClick(subscriptionResponse?.agreementLink);" id="view-agreement"
              target="_blank" ngbTooltip="View Agreement" placement="bottom">
            </div>
          </div>
        </div>
      </div>
      <div class="row"
        *ngIf="!isSubscriptionResponseLoading && (subscriptionResponse?.status == 'Success'  || subscriptionResponse?.status == 'MCA')">
        <div class="col-sm">
          <label class="lable-title">
            STATUS
          </label>
          <p class="paragraph-text">{{subscriptionResponse?.message}}</p>
        </div>
        <div class="col-sm">
          <label class="lable-title">
            ACCEPTED BY
          </label>
          <p class="paragraph-text">
            {{subscriptionResponse?.agreedVersion?.out_first_name}}
            {{subscriptionResponse?.agreedVersion?.out_last_name}}
          </p>
          <p class="paragraph-text">
            {{subscriptionResponse?.agreedVersion?.out_email}}
          </p>
          <p class="paragraph-text">
            {{subscriptionResponse?.agreedVersion?.out_phone}}
          </p>
        </div>
        <div class="col-sm">
          <button class="button button-red button-mid button-agreement view-agreement"
            *ngIf="subscriptionResponse?.status == 'Fail'" (click)="updateAgreement()">
            Re-Sign Agreement</button>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>